import Player from '@vimeo/player';

export default class DirectorVideoList {
    constructor($el) {
        this.$el = $el;
        this.$activeTile = null;

        this.handleMouseEnter = this.handleMouseEnter.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleVimeoConsent = this.handleVimeoConsent.bind(this);

        this.$el.querySelectorAll('[data-director-video-tile]').forEach(($tile) => {
            $tile.addEventListener('mouseenter', this.handleMouseEnter);
            $tile.addEventListener('mouseleave', this.handleMouseLeave);
            $tile.closest('a').addEventListener('click', this.handleClick);
        });

        document.addEventListener('vimeo-consent-granted', this.handleVimeoConsent);
        document.addEventListener('vimeo-consent-revoked', this.handleVimeoConsent);
    }

    handleMouseEnter(event) {
        this.playTile(event.currentTarget);
    }

    handleMouseLeave(event) {
        this.stopTile(event.currentTarget);
    }

    handleClick(event) {
        const $tile = event.currentTarget.querySelector('[data-director-video-tile]');

        if ($tile) {
            this.stopTile($tile);
        }
    }

    handleVimeoConsent() {
        if (this.$activeTile && this.$activeTile.matches(':hover')) {
            this.playTile(this.$activeTile);
        }
    }

    playTile($tile) {
        if (this.$activeTile && this.$activeTile !== $tile) {
            this.stopTile(this.$activeTile);
        }

        this.$activeTile = $tile;

        const $video = $tile.querySelector('video, iframe[src]');

        if ( ! $video) {
            return;
        }

        if ($video.tagName === 'IFRAME') {
            this.playVimeo($tile, $video);
        } else {
            $video.muted = false;
            $video.volume = 1;

            const playPromise = $video.play();

            if (playPromise) {
                playPromise
                    .then(() => this.markAsPlaying($tile))
                    .catch(() => this.playNativeMuted($tile, $video));
            } else {
                this.markAsPlaying($tile);
            }
        }
    }

    playNativeMuted($tile, $video) {
        if (this.$activeTile !== $tile) {
            return;
        }

        $video.muted = true;

        const playPromise = $video.play();

        if (playPromise) {
            playPromise
                .then(() => this.markAsPlaying($tile))
                .catch(() => {});
        }
    }

    playVimeo($tile, $iframe) {
        const player = $iframe.player || new Player($iframe);
        $iframe.player = player;

        player.ready()
            .then(() => {
                if (this.$activeTile !== $tile) {
                    return null;
                }

                return player.setMuted(false);
            })
            .then(() => {
                if (this.$activeTile !== $tile) {
                    return null;
                }

                return player.setVolume(1);
            })
            .then(() => {
                if (this.$activeTile !== $tile) {
                    return null;
                }

                return player.play();
            })
            .then(() => this.markAsPlaying($tile))
            .catch(() => this.playVimeoMuted($tile, player));
    }

    playVimeoMuted($tile, player) {
        if (this.$activeTile !== $tile) {
            return;
        }

        player.setMuted(true)
            .then(() => {
                if (this.$activeTile !== $tile) {
                    return null;
                }

                return player.play();
            })
            .then(() => this.markAsPlaying($tile))
            .catch(() => {});
    }

    markAsPlaying($tile) {
        if (this.$activeTile === $tile && $tile.matches(':hover')) {
            $tile.classList.add('video-tile--playing');
        }
    }

    stopTile($tile) {
        const $video = $tile.querySelector('video, iframe[src]');

        $tile.classList.remove('video-tile--playing');

        if (this.$activeTile === $tile) {
            this.$activeTile = null;
        }

        if ( ! $video) {
            return;
        }

        if ($video.tagName === 'IFRAME') {
            if ($video.player) {
                this.handlePlayerPromise(
                    $video.player.pause().then(() => $video.player.setCurrentTime(0))
                );
            }
        } else {
            $video.pause();
            $video.currentTime = 0;
        }
    }

    handlePlayerPromise(promise) {
        if (promise && typeof promise.catch === 'function') {
            promise.catch(() => {});
        }
    }
}
